import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import Loading from '../Modals/Loading';
import quotationService from '../Services/quotationService';

const UpdateQuotation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { quotation: initialQuotation } = location.state;

    const [quotation, setQuotation] = useState(initialQuotation);
    const [details, setDetails] = useState(initialQuotation.details || []);
    const [loading, setLoading] = useState(false);

    const handleChange = (index, field, value) => {
        const updated = [...details];
        const item = { ...updated[index] }; // Clone object to avoid mutation
        item[field] = ['price', 'quantity', 'vat_percentage'].includes(field)
            ? parseFloat(value)
            : value;
        updated[index] = item;
        setDetails(updated);
    };
    

    const addRow = () => {
        setDetails([
            ...details,
            {
                vendor_code: '',
                brand: '',
                weight: '',
                price: 0,
                quantity: 1,
                vat_percentage: 5,
            }
        ]);
    };

    const removeRow = (index) => {
        const updated = [...details];
        updated.splice(index, 1);
        setDetails(updated);
    };

    const handleSubmit = async () => {
        setLoading(true);

        const amount = parseFloat(totalPrice);
        const vat_amount = parseFloat(totalInclVat);  
        const updatedQuotation = {
            ...quotation,
            customer: quotation.customer_id,
            quotation_date: moment(quotation.quotation_date).format('YYYY-MM-DD'),
            amount,
            vat_amount,
            details
        };
        try {
            await quotationService.update(quotation.id, updatedQuotation);
            alert('Quotation updated successfully!');
            navigate(`/quotation/view?id=${quotation.id}`);
        } catch (error) {
            console.error(error);
            alert('Failed to update quotation');
        }
        setLoading(false);
    };

    const totalPrice = details.reduce((acc, item) => acc + item.quantity * item.price, 0).toFixed(2);
    const totalVat = details.reduce((acc, item) => acc + (item.quantity * item.price * item.vat_percentage) / 100, 0).toFixed(2);
    const totalInclVat = (parseFloat(totalPrice) + parseFloat(totalVat)).toFixed(2);

    return (
        <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
            {loading ? (
                <div className="mt-64">
                    <Loading />
                </div>
            ) : (
                <>
                    <div className="flex flex-row justify-between items-center mb-4">
                        <h1 className="text-2xl font-bold text-gray-800">Update Quotation - {quotation.id}</h1>
                        <button onClick={handleSubmit} className="button-primary">Submit Changes</button>
                    </div>

                    <div className="flex gap-4 text-sm mb-4">
                        <span className="bg-gray-100 px-4 py-1 rounded-full text-gray-700 font-medium">
                            <strong>Created At:</strong> {moment(quotation.created_at).format('LL')}
                        </span>
                        <span className="bg-gray-100 px-4 py-1 rounded-full text-gray-700 font-medium">
                            <strong>Quotation Date:</strong> {moment(quotation.quotation_date).format('LL')}
                        </span>
                    </div>

                    <h2 className="text-lg font-semibold text-gray-700 mb-2">Customer Details</h2>
                    <div className="bg-gray-50 p-4 rounded-md mb-6">
                        <p><strong>Name:</strong> {quotation.customer}</p>
                        <p><strong>Phone:</strong> {quotation.phone}</p>
                        <p><strong>Email:</strong> {quotation.email}</p>
                    </div>

                    <h2 className="text-lg font-semibold text-gray-700 mb-2">Quotation Items</h2>
                    <div className="mb-2">
                        <button
                            onClick={addRow}
                            className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded shadow"
                        >
                            + Add Row
                        </button>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full border text-sm">
                            <thead className="bg-gray-100 text-gray-700">
                                <tr>
                                    <th className="py-2 px-4">#</th>
                                    <th className="py-2 px-4">Vendor Code</th>
                                    <th className="py-2 px-4">Brand</th>
                                    <th className="py-2 px-4">Weight</th>
                                    <th className="py-2 px-4">Price (AED)</th>
                                    <th className="py-2 px-4">Quantity</th>
                                    <th className="py-2 px-4">VAT (%)</th>
                                    <th className="py-2 px-4">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {details.map((item, index) => (
                                    <tr key={index} className="border-t">
                                        <td className="px-4 py-2">{index + 1}</td>
                                        <td className="px-4 py-2">
                                            <input
                                                type="text"
                                                value={item.vendor_code}
                                                onChange={(e) => handleChange(index, 'vendor_code', e.target.value)}
                                                className="w-32 border rounded px-2 py-1"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                            <input
                                                type="text"
                                                value={item.brand}
                                                onChange={(e) => handleChange(index, 'brand', e.target.value)}
                                                className="w-32 border rounded px-2 py-1"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                            <input
                                                type="text"
                                                value={item.weight}
                                                onChange={(e) => handleChange(index, 'weight', e.target.value)}
                                                className="w-24 border rounded px-2 py-1"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                            <input
                                                type="number"
                                                value={item.price}
                                                onChange={(e) => handleChange(index, 'price', e.target.value)}
                                                className="w-24 border rounded px-2 py-1"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                            <input
                                                type="number"
                                                value={item.quantity}
                                                onChange={(e) => handleChange(index, 'quantity', e.target.value)}
                                                className="w-24 border rounded px-2 py-1"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                            <input
                                                type="number"
                                                value={item.vat_percentage}
                                                onChange={(e) => handleChange(index, 'vat_percentage', e.target.value)}
                                                className="w-24 border rounded px-2 py-1"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                            <button
                                                onClick={() => removeRow(index)}
                                                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="mt-6 text-sm bg-gray-50 p-4 rounded-md">
                        <p><strong>Total Price (Excl. VAT):</strong> {totalPrice} AED</p>
                        <p><strong>Total VAT:</strong> {totalVat} AED</p>
                        <p><strong>Total Price (Incl. VAT):</strong> {totalInclVat} AED</p>
                    </div>
                </>
            )}
        </main>
    );
};

export default UpdateQuotation;
